// extracted by mini-css-extract-plugin
export default {"bg":"style_bg__75bZ2","title":"style_title__0Szwc","light":"style_light__F8nBr","dark":"style_dark__ZEucH"};